import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledSmokingCessationTrackerIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 12,
			fill: "#D5F0F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5457 26.8541L8.7072 25.0156C8.31667 24.6251 8.31667 23.9919 8.7072 23.6014L9.27067 23.0379L10.5413 21.7673L11.8118 20.4968L13.0824 19.2262L15.3407 16.9678C15.5919 16.7167 16.0174 16.8001 16.1551 17.1275L16.3939 17.6947C16.4648 17.8632 16.6221 17.9796 16.8041 17.9982L18.1819 18.1384C18.3639 18.1569 18.5212 18.2733 18.5921 18.4419L18.989 19.3848C19.0678 19.5722 19.0254 19.7886 18.8817 19.9323L16.3351 22.4789L15.0645 23.7494L13.7939 25.02L12.5234 26.2906L11.9599 26.8541C11.5694 27.2446 10.9362 27.2446 10.5457 26.8541Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5453 26.928L8.70681 25.0895C8.31628 24.699 8.31628 24.0658 8.70681 23.6753L13.082 19.3L16.3347 22.5527L11.9595 26.928C11.569 27.3185 10.9358 27.3185 10.5453 26.928Z",
			fill: "#4B7987"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.2323 17.641C18.5963 17.6781 18.9109 17.9108 19.0528 18.248L19.4496 19.1909C19.6073 19.5656 19.5225 19.9985 19.235 20.2859L12.3132 27.2077C11.7274 27.7935 10.7777 27.7935 10.1919 27.2077L8.35344 25.3692C7.76765 24.7834 7.76765 23.8337 8.35344 23.2479L14.987 16.6143C15.4892 16.1121 16.3403 16.2789 16.6158 16.9335L16.8545 17.5008L18.2323 17.641ZM18.5279 19.5788L18.1311 18.6359L16.7532 18.4956C16.3893 18.4586 16.0747 18.2258 15.9328 17.8887L15.6941 17.3214L13.7893 19.2262L16.3349 21.7718L18.5279 19.5788ZM15.6278 22.4789L13.0822 19.9333L12.5187 20.4968L13.2494 21.2275C13.4447 21.4227 13.4447 21.7393 13.2494 21.9346C13.0542 22.1298 12.7376 22.1298 12.5423 21.9346L11.8116 21.2039L11.2482 21.7674L11.4367 21.9559C11.632 22.1512 11.632 22.4678 11.4367 22.663C11.2415 22.8583 10.9249 22.8583 10.7296 22.663L10.541 22.4745L9.97757 23.038L11.2504 24.3108C11.4456 24.506 11.4456 24.8226 11.2504 25.0179C11.0551 25.2131 10.7385 25.2131 10.5433 25.0179L9.27047 23.7451L9.06054 23.955C8.86528 24.1502 8.86528 24.4668 9.06054 24.6621L10.899 26.5006C11.0943 26.6958 11.4109 26.6958 11.6061 26.5006L11.8161 26.2906L11.6275 26.1021C11.4322 25.9068 11.4322 25.5902 11.6275 25.395C11.8228 25.1997 12.1393 25.1997 12.3346 25.395L12.5232 25.5835L13.0866 25.0201L11.8138 23.7473C11.6186 23.552 11.6186 23.2354 11.8138 23.0402C12.0091 22.8449 12.3257 22.8449 12.5209 23.0402L13.7937 24.313L14.3572 23.7495L13.6265 23.0188C13.4313 22.8235 13.4313 22.507 13.6265 22.3117C13.8218 22.1164 14.1384 22.1164 14.3336 22.3117L15.0643 23.0424L15.6278 22.4789Z",
			fill: "#333333"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.8117 17.7945L22.6603 19.1942C22.6408 19.3741 22.5257 19.5294 22.3592 19.6003L21.7693 19.8517C21.4435 19.9906 21.3613 20.4148 21.6118 20.6652L27.6592 26.7127C27.8867 26.9402 28.2555 26.9402 28.483 26.7127L29.7187 25.477L30.9543 24.2413C31.1818 24.0139 31.1818 23.645 30.9543 23.4176L24.6224 17.0856C24.4781 16.9413 24.2606 16.8992 24.0728 16.9792L23.1128 17.3883C22.9463 17.4593 22.8312 17.6146 22.8117 17.7945Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.3147 17.8013C22.3536 17.4415 22.5839 17.1308 22.9168 16.9889L23.8768 16.5798C24.2523 16.4197 24.6874 16.504 24.976 16.7926L31.3079 23.1245C31.6032 23.4198 31.6923 23.8432 31.575 24.2158C32.1412 24.803 32.1347 25.738 31.5555 26.3172L30.4984 27.3743C29.9192 27.9535 28.9842 27.96 28.397 27.3939C28.0244 27.5111 27.601 27.422 27.3057 27.1268L21.2583 21.0793C20.7574 20.5785 20.9217 19.73 21.5733 19.4523L22.1632 19.2009L22.3147 17.8013ZM29.2063 26.757C29.3948 26.8555 29.6329 26.8255 29.7913 26.6672L30.8484 25.6101C31.0067 25.4518 31.0367 25.2137 30.9382 25.0251L29.2063 26.757ZM24.2689 17.4997L23.3089 17.9088L23.1574 19.3085C23.1185 19.6683 22.8882 19.979 22.5553 20.1208L21.9654 20.3722L28.0128 26.4197C28.045 26.4519 28.0973 26.4519 28.1295 26.4197L30.6008 23.9483C30.6331 23.9161 30.6331 23.8639 30.6008 23.8316L24.2689 17.4997Z",
			fill: "#333333"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20 9C20.2761 9 20.5 9.22386 20.5 9.5V13.5C20.5 13.7761 20.2761 14 20 14C19.7239 14 19.5 13.7761 19.5 13.5V9.5C19.5 9.22386 19.7239 9 20 9Z",
			fill: "#333333"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.8282 15.1213C18.0234 14.926 18.0234 14.6095 17.8282 14.4142L15.2069 11.7929C15.0116 11.5976 14.695 11.5976 14.4998 11.7929C14.3045 11.9882 14.3045 12.3047 14.4998 12.5L17.1211 15.1213C17.3163 15.3166 17.6329 15.3166 17.8282 15.1213Z",
			fill: "#333333"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.1464 15.1213C21.9512 14.926 21.9512 14.6095 22.1464 14.4142L24.7929 11.7677C24.9882 11.5725 25.3047 11.5725 25.5 11.7677C25.6953 11.963 25.6953 12.2796 25.5 12.4749L22.8536 15.1213C22.6583 15.3166 22.3417 15.3166 22.1464 15.1213Z",
			fill: "#333333"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledSmokingCessationTrackerIcon);
const Memo = memo(ForwardRef);
export default Memo;
